import { render, staticRenderFns } from "./DetailsFroms.vue?vue&type=template&id=3ba3a50c&scoped=true&"
import script from "./DetailsFroms.vue?vue&type=script&lang=js&"
export * from "./DetailsFroms.vue?vue&type=script&lang=js&"
import style0 from "./DetailsFroms.vue?vue&type=style&index=0&id=3ba3a50c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba3a50c",
  null
  
)

export default component.exports